/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc);
};

jQuery(function($) {

  /* Placeholder JS */
  /*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });
  }

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });

  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('.product-photo-thumb a').on('click', function(e) {
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
  } );

});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Navigation
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

function openNavigation() {
  $('.navigation, .navigation-curtain').removeClass('is-hidden');
}

function closeNavigation() {
  $('.navigation, .navigation-curtain').addClass('is-hidden');
  $('.navigation__list__item__button').removeClass('is-inactive');
  $('.navigation__section__column--sub-navigation').addClass('is-hidden');
}

// Toggle navgiation
$('.js-toggle-navigation').click(function() {

  if ($('.navigation').hasClass('is-hidden')) {
    openNavigation();

  } else {
    closeNavigation();
  }

});

// Close navigation when clicking outside of navigation
$('.navigation, .js-toggle-navigation').click(function(e) {
  e.stopPropagation();
});

$(document).click(function() {
  closeNavigation();
});

// Close navigation when pressing 'esc'
$(document).on('keyup', function(evt) {
  if (evt.keyCode == 27) {
    closeNavigation();
  }
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Sub-navigation
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.js-open-sub-navigation').click(function(e) {

  var selectedSubNavigation = $(this).data('title');

  $(this).removeClass('is-inactive').parent().siblings('.navigation__list__item').find('.navigation__list__item__button').addClass('is-inactive');

  $('.navigation__section__column--sub-navigation').addClass('is-hidden');
  $('.navigation__section__column--sub-navigation[data-title=' + selectedSubNavigation + ']').removeClass('is-hidden');

  e.preventDefault();

});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Additional product information
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

function updateProductInformationCurtain() {

  var productInformationParent = $('.product-detail__block--information');
  var productInformation = $('.product-information__additional__item:last-child');

  if (productInformationParent) {
    var productInformationParentBottomOffset = Math.round($(productInformationParent).offset().top + $(productInformationParent).outerHeight(true));
    var productInformationBottomOffset = Math.round($(productInformation).offset().top + $(productInformation).outerHeight(true));
    var productInformationDifference = (productInformationBottomOffset - productInformationParentBottomOffset);
  }

  if ($(window).width() >= 1024 && $('.tenue-skin').length > 0) {
    $('.product-detail__block__curtain').height(productInformationDifference + 80 + 140);
  } else {
    $('.product-detail__block__curtain').height(productInformationDifference + 80);
  }

}

$('.product-information__additional__item__button').click(function(e) {
  $(this).parent().toggleClass('is-open').siblings().removeClass('is-open');
  updateProductInformationCurtain();
});

$('.product-information__additional').click(function(e) {
  e.stopPropagation();
});

if ($('.product-detail__block--information').length > 0) {

  $(window).resize(function() {
    updateProductInformationCurtain();
  });

}

function closeAdditionalProductInformation() {
  $('.product-information__additional__item').removeClass('is-open');
  updateProductInformationCurtain();
}

// Close additional product information when clicking outside of additional product information
$(document).click(function() {
  closeAdditionalProductInformation();
});

// Close navigation when pressing 'esc'
$(document).on('keyup', function(evt) {
  if (evt.keyCode == 27) {
    closeAdditionalProductInformation();
  }
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Carousel
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.carousel').owlCarousel({
  'loop': true,
  'smartSpeed': 800,
  'dots': true,
  'nav': false,
  'autoplay': true,
  'autoplayTimeout': 4000,
  'autoplayHoverPause': false,
  'items': 1,
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Product carousel
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.product-carousel').owlCarousel({
  'loop': true,
  'smartSpeed': 800,
  'dots': false,
  'nav': true,
  'autoplay': false,
  'autoplayTimeout': 4000,
  'autoplayHoverPause': false,
  'items': 1,
  'navText': ["<img src='//www.tenuejeans.com/cdn/shop/t/57/assets/ico-caret-down-black.svg?v=19528750866379402961758812888'>","<img src='//www.tenuejeans.com/cdn/shop/t/57/assets/ico-caret-down-black.svg?v=19528750866379402961758812888'>"],
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Homepage sliders
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---


$('.js-slider').flickity({
  cellAlign: 'left',
  autoplay: 2000,
  pauseAutoPlayOnHover: false,
  pageDots: true,
  groupCells: true,
  wrapAround: true,
  lazyLoad: true,
  prevNextButtons: false,
  setGallerySize: false
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Page heading
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.js-toggle-page-heading-sections').click(function(e) {
  $('.page-heading__section--toggle').toggleClass('is-hidden');
  e.preventDefault();
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Product description
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.js-toggle-product-description').click(function(e) {
  $('.product-information__description--toggle').toggleClass('is-hidden');
  e.preventDefault();
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Sort by collection pages - S&T. (Should we add an active indicator to the button?)
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('#sort-by button').click(function(e){
  var sortBy = $(this).attr('data-value');
  console.log(sortBy);

  Shopify.queryParams.sort_by = sortBy;
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');

  e.preventDefault();
})

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Add to cart product.liquid section
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.js-add-to-cart').click(function(e){
  var id = $('#variant option:selected').val(),
      quantity = $('#quantity').val();
      if(e.target.dataset.available === 'YXZhaWxhYmxl' && !e.target.classList.contains('disabled')) {
        addToCart(id,quantity);
      }
  e.preventDefault();
})

function addToCart(id,quantity){

  var data = {
    id: id,
    quantity: quantity
  }

  $.ajax({
    url: `${window.Shopify.routes.root}cart/add.js`,
    dataType: 'json',
    async: true,
    data: data,
    success: function(product) {
      added();
      updateCart();
      displayMessage(false);
    },//end succes call
    error: function(error) {
      displayMessage(true,error.responseJSON.description);
    }//end error call
  });

  function added(){
    //set text in add to cart button and reset after 1500ms
    var cartBtn = $('.js-add-to-cart');
    var txt = 'ADD TO CART';
    cartBtn.text('ADDED TO CART');
    cartBtn.addClass('product-information__options__button--added')
    setTimeout(function(){
      if (cartBtn.hasClass('product-information__options__button--preorder')) {
        cartBtn.text('PRE ORDER');
      } else {
        cartBtn.text(txt);
        cartBtn.removeClass('product-information__options__button--added')
      }
    },1500);
  }

  function displayMessage(status=false,message=""){
    //status refers to if the messageField should be displayed or be hidden after another action
    // true = show
    // false = hide
    var messageField = $('#messageField, #messageField2');
    if(status){
      messageField.text(message);
      messageField.removeClass('is-hidden');
    }else{
      messageField.text(message);
      messageField.addClass('is-hidden');
    }
  }

  function updateCart(){
    var headerCart = $('#js-cart-quantity'),
        itemCount;

    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      async: false,
      success: function(cart) {
        itemCount = cart.item_count;
      },//end succes call
      error: function(error) {
        console.log(error);
      }//end error call
    });

    if(itemCount > 0) {
      headerCart.text(itemCount);
      headerCart.addClass('dot--active');
    } else{
      headerCart.text('');
      headerCart.removeClass('dot--active')
    }
  }
};

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Edit quantitys cart.liquid - S&T
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.js-minus').click(function(e){
  var currentQ = $(this).next().text(),
      id = $(this).parents('.cart-item[data-id]').attr('data-id');
  var newQ = parseInt(currentQ)-1;
  editLineItem(id, newQ);
  e.preventDefault();
});

$('.js-plus').click(function(e){
  var currentQ = $(this).prev().text(),
      id = $(this).parents('.cart-item[data-id]').attr('data-id');
  var newQ =  parseInt(currentQ)+1;
  editLineItem(id, newQ);
  e.preventDefault();
});

$('.js-remove').click(function(e){
  let id = $(this).parents('.cart-item[data-id]').attr('data-id');
  let newQ = 0;
  editLineItem(id, newQ);
  e.preventDefault();
});

function editLineItem(id, quantity){

  var data = {
    id: id,
    quantity: quantity
  }

  $.ajax({
    url: `${window.Shopify.routes.root}cart/change.js`,
    dataType: 'json',
    data: data,
    async: true,
    success: function(cart) {
      var error = false;

      cart.items.forEach(function(item) {
        if(item.id == id && item.quantity !== quantity){
          alert('Er zijn niet meer dan '+ item.quantity +' '+ item.title+' beschikbaar');
          error = true;
        }
      });

      if(!error){location.reload()}

    },//end succes call
    error: function(error) {
      console.log(error);
    }//end error call
  });
}

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Replace tag filtering - S&T
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---



// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Toggle filter/sort tabs collections pages - S&T
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---


$('.product-filter__button.js-open').click(function(e){
  $('.product-filter__column').removeClass('is-open').addClass('is-closed');
  $(this).parents('.product-filter__column').removeClass('is-closed').addClass('is-open');
  e.preventDefault();
});


// /brand_bru-na-boinne+size_31
// See http://stackoverflow.com/a/3561711/556609

String.prototype.replaceAll = function(strReplace, strWith) {
    var esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    var reg = new RegExp(esc, 'ig');
    return this.replace(reg, strWith);
};

function replaceTag(tag, currenttag){
  var url = window.location.href;
  var newUrl = url.replaceAll(currenttag, tag);
  window.location.href = newUrl;
}

function addTag(parameter, current_tags){
  parameter = decodeURIComponent(parameter);
  var url = window.location.href;
  url = url.replaceAll('#', '');
  var last = new URL(url).pathname.split('/').pop();
  if(last.includes("_") && !last.includes('sort_by')){
    var newlast = last+'+'+parameter;
    var newUrl = url.replaceAll(last, newlast);
  }else if(url.includes('sort_by')){
    var sort = url.split("?").pop();
    sort = '?'+sort;
    var newUrl = url.replaceAll(sort, '');
    newUrl = newUrl+'/'+parameter+sort;
  }else if(current_tags == true){
    var newUrl = url+'/'+parameter;
  }else{
    var newUrl = url+'/'+parameter;
  }
  newUrl = newUrl.replaceAll('++', '+');
  newUrl = newUrl.replace(/([^:]\/)\/+/g, "$1");
  window.location = newUrl;
}

function removeTag(parameter){
  parameter = decodeURIComponent(parameter);
  var url = window.location.href;
  url = url.replaceAll('#', '');
  var newUrl = url.replaceAll(parameter, '');
  newUrl = newUrl.replaceAll('/+', '/');
  newUrl = newUrl.replaceAll('++', '+');
  newUrl = newUrl.replace(/([^:]\/)\/+/g, "$1");
  window.location.href = newUrl;
}

/* Function to set current tags */
var url = window.location.href;
url = url.replaceAll('#', '');
var last = new URL(url).pathname.split('/').pop();
var currentFilter = $('#currentFilters');
if(last.includes("_")){
  var params = last.split("+");
  for (i = 0; i < params.length; i++) {
    var param = params[i].split("_").pop();
    var key = params[i].split("_").shift();
    if(!params[i].includes('size_')){param = param.replaceAll('-', ' ');}
    currentFilter.find("[data-val='"+key+"']").text('- '+param).attr('onCLick','removeTag("'+params[i]+'")').removeClass('is-hidden');
  }
}















